import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function getCommonTimezone(params) {
  return request({
    url: `${v2Host}/common/timezone`,
    method: 'get',
    params,
  })
}

export function loginSs(params) {
  return request({
    url: `${v2Host}/login-ss`,
    method: 'get',
    params,
  })
}

export function uploadIcon(data) {
  return request({
    url: '/common/upload/icon',
    method: 'post',
    data: data,
  })
}

export function getUrlIcon(query) {
  return request({
    url: `${v2Host}/system/app/info`,
    method: 'get',
    params: query,
  })
}

export function getTagList(query) {
  return request({
    url: `${v2Host}/common/tag/list`,
    method: 'get',
    params: query,
  })
}

export function getCommonConfig(params) {
  return request({
    url: `${v2Host}/common/config`,
    method: 'get',
    params,
  })
}
